import { defineMessages } from "react-intl";

const messages = defineMessages({
    slogen: {
        id: "choir.slogen",
    },
    description: {
        id: "choir.seo.description",
    },
});

export default messages;
